export default __webpack_public_path__ + "static/media/tisch.edebc29a.png";